import { Typography } from '@mui/material';

export default function Title(props) {
  const variant = props?.variant ?? 'h6';
  const style = props?.style ?? {};
  const textProps = props?.textProps ?? {};
  return (
    <Typography variant={variant} sx={{ margin: 0 }} {...textProps} style={style}>
      {props.label}
    </Typography>
  );
}
